import { __decorate } from 'tslib';
// -----------------------------------------------------------------------------------------------------------------
// Restricted - Copyright (C) Siemens Healthineers AG 2023.
// -----------------------------------------------------------------------------------------------------------------
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { sharedStyles } from '../../styles';
import boxStyles from './sh-box.lit.scss.js';
let SHBoxFooter = class SHBoxFooter extends LitElement {
  constructor() {
    super(...arguments);
    /** Defines the divider style for the footer. Valid values are 'none', 'inset', or 'full-width', determining the appearance of the divider between the footer and the box content. */
    this.divider = 'none';
  }
  static get styles() {
    return [sharedStyles, boxStyles];
  }
  render() {
    return html`
      <slot></slot>
      ${this.divider && (this.divider === 'inset' || this.divider === 'full-width')
        ? html`<div class="footer-divider-wrapper"></div>`
        : html``}
    `;
  }
  attributeChangedCallback(name, oldval, newval) {
    super.attributeChangedCallback(name, oldval, newval);
    if (!['wide', 'compact', 'supercompact', 'none'].includes(newval)) {
      const paddingAttributes = ['padding-top', 'padding-right', 'padding-bottom', 'padding-left'];
      if (name === 'padding') {
        this.style.setProperty(`--container-padding`, newval || `var(--container-padding)`);
        for (const eachItem of paddingAttributes) {
          this.style.setProperty(`--${eachItem}`, newval || `var(--${eachItem})`);
        }
      } else if (paddingAttributes.includes(name)) {
        this.style.setProperty(`--${name}`, newval || `var(--${name})`);
      }
    }
  }
};
__decorate(
  [property({ type: String, reflect: true })],
  SHBoxFooter.prototype,
  'background',
  void 0
);
__decorate([property({ type: String, reflect: true })], SHBoxFooter.prototype, 'padding', void 0);
__decorate(
  [property({ type: String, reflect: true, attribute: 'padding-top' })],
  SHBoxFooter.prototype,
  'paddingTop',
  void 0
);
__decorate(
  [property({ type: String, reflect: true, attribute: 'padding-right' })],
  SHBoxFooter.prototype,
  'paddingRight',
  void 0
);
__decorate(
  [property({ type: String, reflect: true, attribute: 'padding-bottom' })],
  SHBoxFooter.prototype,
  'paddingBottom',
  void 0
);
__decorate(
  [property({ type: String, reflect: true, attribute: 'padding-left' })],
  SHBoxFooter.prototype,
  'paddingLeft',
  void 0
);
__decorate(
  [property({ type: String, reflect: true, attribute: 'divider' })],
  SHBoxFooter.prototype,
  'divider',
  void 0
);
SHBoxFooter = __decorate([customElement('sh-box-footer')], SHBoxFooter);
export { SHBoxFooter };
